import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private dbSubscription?: Subscription;
  private channelPath?: string;

  private statusSubject = new BehaviorSubject<any>(null);
  status$ = this.statusSubject.asObservable();

  constructor(private db: AngularFireDatabase) {}

  initRealTimeDB(channelId: any) {
    console.log('Firebase channel:', channelId);

    this.channelPath = `anonymous_device_room/${channelId.channel_id}`;
    this.attachDatabaseListener();
  }

  private attachDatabaseListener() {
    if (!this.channelPath || this.dbSubscription) return;

    this.dbSubscription = this.db
      .object(this.channelPath)
      .valueChanges()
      .subscribe({
        next: (data: any) => {
          const status = data?.status;
          console.log('Firebase status changed:', status);
          this.statusSubject.next(data);
        },
        error: (error) => {
          console.warn('Firebase read failed:', error);
        }
      });

    console.log('Database listener attached');
  }

  detachListener() {
    if (this.dbSubscription) {
      this.dbSubscription.unsubscribe();
      this.dbSubscription = undefined;
    }
  }
}
